export default __webpack_public_path__ + "static/media/28.2ccf6a6c.svg";